// Importar íconos de MUI
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedinIcon from "@mui/icons-material/LinkedIn";

// Importar componentes de Material Kit 2 PRO React
import MKTypography from "components/MKTypography";

// Importar imágenes
import logoCT from "assets/images/logos/pwncat.svg";

// Obtener el año actual
const date = new Date().getFullYear();

// Definir la configuración de las rutas del pie de página
const footerRoutes = {
  brand: {
    name: "PWNCAT",
    image: logoCT,
    route: "/",
    description: "Servicios de ciberseguridad ofensiva",
  },
  socials: [
    {
      icon: <TwitterIcon />,
      link: "https://x.com/k0x_offsec",
    },
    {
      icon: <GitHubIcon />,
      link: "https://github.com/orgs/pwncat-offsec",
    },
    {
      icon: <LinkedinIcon />,
      link: "https://www.linkedin.com/company/96064718",
    },
  ],
  menus: [
    {
      name: "Compañía",
      items: [
        { name: "Visión General", href: "/company/overview" },
        { name: "Nuestra Marca", href: "/company/our-brand" },
        { name: "Carrera", href: "/company/career" },
      ],
    },
    {
      name: "Soporte",
      items: [
        { name: "Contáctanos", href: "/support/contact-us" },
        { name: "Privacidad", href: "/support/privacy" },
      ],
    },
    {
      name: "Recursos",
      items: [
        { name: "Blog", href: "" },
        { name: "I+D", href: "mailto:research@pwncat.com" },
        { name: "Educativo", href: "/services/traning-and-awareness" },
      ],
    },
    {
      name: "Idiomas",
      items: [
        { name: "Inglés", href: "https://en.pwncat.com" },
      ],
    },
  ],
  // Definir la información de derechos de autor
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Todos los derechos reservados. Copyright &copy; {date} por{" "}
      <MKTypography
        component="a"
        href="https://www.pwncat.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        PWNCAT S.L
      </MKTypography>
    </MKTypography>
  ),
};

export default footerRoutes;